import React from 'react';
import './UpgradeModal.css';

const UpgradeModal = ({ isOpen, onClose, onUpgrade }) => {
  if (!isOpen) return null;

  return (
    <div className="upgrade-modal-overlay" onClick={onClose}>
      <div className="upgrade-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="upgrade-modal-close" onClick={onClose} aria-label="Close">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
        
        <div className="upgrade-modal-header">
          <div className="upgrade-modal-icon">
            <svg width="48" height="48" viewBox="0 0 256 256" fill="white" xmlns="http://www.w3.org/2000/svg">
              <path d="M238.72754,73.53516a15.90424,15.90424,0,0,0-16.70508-2.29981l-50.584,22.48242L141.98633,40.70312a15.999,15.999,0,0,0-27.97266,0L84.56055,93.7168,33.96875,71.23145A16.00031,16.00031,0,0,0,11.89551,89.51172l25.44531,108.333a15.83567,15.83567,0,0,0,7.4082,10.09179,16.15491,16.15491,0,0,0,12.49317,1.65137,265.89708,265.89708,0,0,1,141.46875-.01367,16.15265,16.15265,0,0,0,12.4873-1.65137,15.83531,15.83531,0,0,0,7.40821-10.084L244.0957,89.52051A15.90513,15.90513,0,0,0,238.72754,73.53516Z"></path>
            </svg>
          </div>
          <h2 className="upgrade-modal-title">Upgrade Your Plan</h2>
          <p className="upgrade-modal-subtitle">
            You've reached the limit for Basic plan. View our pricing to upgrade and unlock more features.
          </p>
        </div>

        <div className="upgrade-modal-actions">
          <button className="upgrade-modal-button-secondary" onClick={onClose}>
            Maybe Later
          </button>
          <button className="upgrade-modal-button-primary" onClick={onUpgrade}>
            View Pricing
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal;
